import RestModule from "../vue-ocom/store/RestModule";
import schema from "./schema/index";
import CreateUserModule from "../vue-ocom/store/CreateUserModule";

var root_url = process.env.VUE_APP_ROOT_API;

const UserModule = CreateUserModule(root_url);

const MessageModule = RestModule(
  root_url + "/messaging/message/",
  schema.Message
);
const ConversationModule = RestModule(
  root_url + "/messaging/conversation/",
  schema.Conversation
);
const ConversationMemberModule = RestModule(
  root_url + "/messaging/conversation_member/",
  schema.ConversationMember
);
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  UserModule,

  MessageModule,
  ConversationModule,
  ConversationMemberModule,
  //Add more modules here
};
